module.exports = __webpack_public_path__ + "static/media/my-vodafone.ecb88a61.svg";